import { FSetupFetchActionType, FSetupFetchDecorationPayload } from '../types/index.js';

import { useFetchMethodResolver } from './useFetchMethodResolver.js';
import { useResolver } from './useResolver.js';

export interface DecorationHookResolver {
  /**
   * Returns the url for the given key
   */
  (input: number): FSetupFetchDecorationPayload;
  /**
   * Returns an array of urls for the given keys
   */
  (input: number[]): FSetupFetchDecorationPayload[];
}
// TODO: Use this resolver to fetch decoration
export const useDecorationResolver: DecorationHookResolver = (id: any) =>
  useResolver(useFetchMethodResolver(), id, FSetupFetchActionType.Decoration) as any;
